'use strict';
/**
 * @private
 * Represents a warning encountered when
 * interacting with one of Twilio's services.
 */
const TwilioWarning = {
    recordingMediaLost: 'recording-media-lost'
};
module.exports = TwilioWarning;
//# sourceMappingURL=twiliowarning.js.map